import { type GameData, type GameUpdateInput, type GameUpdateSuccess, toResponseError } from '@terros/common'
import { useTantalimMutation } from '../mutation'
import { mutationUpdate, type UpdateHookResponse } from '../hooks'
import { useGameCache } from './cache'

export function useRestoreCompetition(): UpdateHookResponse<GameData, GameData> {
  const cache = useGameCache()
  const mutation = useTantalimMutation<GameUpdateInput, GameUpdateSuccess>({ url: '/game/update' })

  async function restore(game: GameData): Promise<GameData> {
    try {
      const { game: saved } = await mutation.mutateAsync({ game: { ...game, isDeleted: false } })
      cache.updateGameData(saved)
      // Restoring moves the game from the archived list to the active one,
      // which patching the cached rows in place cannot express
      cache.clearList()
      return saved
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, restore)
}
